<template>
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center row wrap>
          <v-flex xs12 sm8 lg4>
            <fcc-registration />
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
</template>

<script>
  import FCCRegistration from './components/FCCRegistration'

  export default {
    data: () => ({
      drawer: null,
    }),
    props: {
      source: String
    },
    components: {
      "fcc-registration": FCCRegistration
    }
  }
</script>